import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

export type ICreateFromLocationsRepo = IRepo<[number[]], IRepoResponse<200> | IRepoResponse<400 | 500, string>>;

export const CreateFromLocationsRepoType = Symbol.for('CreateFromLocationsRepo');

@bind(CreateFromLocationsRepoType)
export class CreateFromLocationsRepo implements ICreateFromLocationsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(locationIds: number[]) {
    try {
      const url = urlMaker('/api/admin/flyex/create-from-locations', { location_ids: locationIds });

      const result = await this.httpClient.post({ url });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400 || result.status === 422) {
        return {
          status: 400 as 400,
          response: Object.values(result.data?.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
